export const paginationQueryVariables = ['first', 'after', 'last', 'before'];

export const defaultPageSize = 20;
